import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

const getDropAnalyticsFn = httpsCallable(functions, "getDropAnalytics");

/**
 * Fetch owner-only per-drop analytics (server aggregates + live pace for open drops).
 */
export async function fetchDropAnalytics(dropId) {
  if (!dropId) throw new Error("Missing dropId.");
  const res = await getDropAnalyticsFn({ dropId });
  return res.data;
}
